/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { Badge, BadgeProps } from '@mantine/core'
import { useQuery } from '@tanstack/react-query'
import { fetchInterventionCount } from '../../lib/rest/interventionAPIClient'

export type InterventionCountBadgeProps = BadgeProps & {
  status: InterventionStatus;
}

function InterventionCountBadge (props: InterventionCountBadgeProps) {
  const { status, ...others } = props

  const query = useQuery({
    queryKey: ['interventionCount', status],
    queryFn: () => fetchInterventionCount({ status }),
    refetchInterval: 1000 * 60 * 10
  })
  const count = query.data?.count

  return (
    <Badge
      variant="outline"
      {...others}
      color={count > 0 ? 'orange' : 'gray'}
      onClick={() => query.refetch()}
    >
      {count}
    </Badge>
  )
}

export default InterventionCountBadge
